import { api } from '../utils/endpoint.js'
import * as dayjs from 'dayjs'
const KEK_TITLES = 'titlesAtom'


const fetchTitles = async () => {
  const fetchData = async () => {
    try {
      const response = await fetch(api.coreService.getTitles('?lang=TH'));
      if (!response.ok) {
        throw new Error('');
      }
      const data = await response.json();
      return data
    } catch (error) {
      console.error(error)
    }
  };
  const responseAll = await fetchData();
  
  const thAll = responseAll.map((item) => {
    return { label: item.name, value: item.pvCode }
  })

  const result = {
    data: {
      ['thai']: thAll,
    },
    expire: dayjs().add(1, 'h').valueOf()
  }

  localStorage.setItem(KEK_TITLES, JSON.stringify(result))
  return result
}

const getTitles = async () => {
  let titlesAtom = JSON.parse(localStorage.getItem(KEK_TITLES) || '{}')
  if (Object.keys(titlesAtom).length === 0) {
    titlesAtom = await fetchTitles()
  }

  if(dayjs().valueOf() > titlesAtom?.expire){
    titlesAtom = await fetchTitles()
  }

  let arrayTitles = {}
  arrayTitles = Object.assign(arrayTitles, { [null]: 'เลือก' })
  titlesAtom?.data.thai.map((item) => {
      arrayTitles = Object.assign(arrayTitles, { [item.value]: item.label })
  })

  const listTitles = formatTitles(titlesAtom?.data.thai)
  return { arrayTitles, listTitles}
}

const formatTitles = (data) => {
  const listData = []
  listData.push({
    id: null,
    name: 'เลือก'
  })
  for (const key in data) {
    if (Object.hasOwnProperty.call(data, key)) {
      listData.push({
        id: data[key].value,
        name: data[key].label
      })
    }
  }
  return listData
}

export { getTitles, fetchTitles }
